(function () {
  'use strict';
  /* Queen Shaped - the figure in the fitting drawer.

     Not a body model: a stylised silhouette whose torso is drawn FROM the three
     measurements, so it reshapes as the shopper adjusts them. Rings sit at bust,
     waist and hip and take their colour from that zone's fit verdict. */

  var CX = 66, W = 132, H = 228;
  var Y = { shoulder: 56, bust: 86, waist: 120, hip: 154, hem: 222 };

  var TONE = {
    'Just right': '#2e9e6b',
    'Fitted': '#c9933a',
    'Relaxed': '#c9933a',
    'Snug': '#c9603a',
    'Loose': '#c9603a',
    'Too tight': '#c0392b'
  };
  function tone(v) { return TONE[v] || '#8a8a8a'; }

  /* 70cm is the narrowest frame the sliders allow, 190cm the widest. */
  function half(cm) {
    var v = Math.max(70, Math.min(190, cm || 100));
    return 11 + (v - 70) * 0.30;
  }
  function r1(n) { return Math.round(n * 10) / 10; }

  function torso(bw, ww, hw, sw) {
    function p(x, y) { return r1(x) + ',' + y + ' '; }
    var hem = hw * 0.58;
    return 'M' + p(CX - sw, Y.shoulder) +
      /* shoulder into bust */
      'C' + p(CX - sw - 2, 70) + p(CX - bw, 76) + p(CX - bw, Y.bust) +
      /* bust into waist - pulled in hard so the nip reads */
      'C' + p(CX - bw, 98) + p(CX - ww - 1, 108) + p(CX - ww, Y.waist) +
      /* waist into hip */
      'C' + p(CX - ww - 1, 138) + p(CX - hw, 142) + p(CX - hw, Y.hip) +
      /* hip into hem */
      'C' + p(CX - hw, 180) + p(CX - hem - 2, 196) + p(CX - hem, Y.hem) +
      'L' + p(CX + hem, Y.hem) +
      'C' + p(CX + hem + 2, 196) + p(CX + hw, 180) + p(CX + hw, Y.hip) +
      'C' + p(CX + hw, 142) + p(CX + ww + 1, 138) + p(CX + ww, Y.waist) +
      'C' + p(CX + ww + 1, 108) + p(CX + bw, 98) + p(CX + bw, Y.bust) +
      'C' + p(CX + bw, 76) + p(CX + sw + 2, 70) + p(CX + sw, Y.shoulder) + 'Z';
  }

  function arm(side, sw, hw) {
    var o = side, x0 = CX + o * (sw - 1);
    return 'M' + r1(x0) + ',60 C' + r1(x0 + o * 9) + ',92 ' + r1(CX + o * (hw + 5)) + ',124 ' +
      r1(CX + o * (hw + 2)) + ',160';
  }

  /* m: {bust,waist,hip} in cm. marks: a verdict per zone, or none. active: the
     zone being edited, drawn emphasised. */
  function figure(m, marks, active) {
    var bw = half(m.bust), ww = half(m.waist), hw = half(m.hip), sw = bw * 0.84;
    marks = marks || {};
    var rings = [['bust', bw], ['waist', ww], ['hip', hw]].map(function (z) {
      var key = z[0], rx = z[1] + 2, y = Y[key];
      var v = marks[key], on = key === active;
      var c = v ? tone(v) : (on ? 'var(--color-foreground)' : 'rgb(from var(--color-foreground) r g b / 22%)');
      return '<ellipse cx="' + CX + '" cy="' + y + '" rx="' + r1(rx) + '" ry="5" fill="none" stroke="' +
        c + '" stroke-width="' + (v || on ? 2.4 : 1.3) + '"' + (on ? ' class="qs-fig__ring--on"' : '') + '/>';
    }).join('');

    return '<svg class="qs-fig" viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-hidden="true">' +
      '<g class="qs-fig__arms" fill="none" stroke-linecap="round">' +
      '<path d="' + arm(-1, sw, hw) + '"/><path d="' + arm(1, sw, hw) + '"/></g>' +
      '<g class="qs-fig__body">' +
      '<circle cx="' + CX + '" cy="24" r="11.5"/>' +
      '<path d="M' + (CX - 4.5) + ',32 L' + (CX + 4.5) + ',32 L' + (CX + 6) + ',58 L' + (CX - 6) + ',58 Z"/>' +
      '<path d="' + torso(bw, ww, hw, sw) + '"/>' +
      '</g>' + rings + '</svg>';
  }

  window.QSFitFigure = { figure: figure, tone: tone };
})();
